import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { ToastrService } from 'toastr-ng2';

@Component({
  selector: 'app-edit-tages',
  templateUrl: './edit-tages.component.html',
  styleUrls: ['./edit-tages.component.scss']
})
export class EditTagesComponent{

tagDetails:any={};
tagsdata: FirebaseObjectObservable<any>;
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase,public toastr: ToastrService) {
  	 	 	this.route.params.map(params => params['id']).subscribe((Id) => {
  	 	if(Id != null) {
		        this.tagsdata = this.af.object('/tags/' + Id);
		        this.tagsdata.subscribe(
		        (response) => { 
		        	this.tagDetails = response;
		         }
		      )
          }
       });
  }
    onSubmitTag(form: NgForm){
    	  this.tagsdata.update({
    	  	tags:this.tagDetails.tags,
    	  }).then((res)=>{
           this.toastr.success('Tags Updated Successfully!', 'Success!');
        this.router.navigate(['/tags/all']);
      })
    }

      cancel(){
       this.router.navigate(['/tags/all']);
    }
}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/tags/edit-tages/edit-tages.component.ts